<ng-content></ng-content>

<dx-tooltip
  *ngIf="_compactMode"
  [target]="target"
  position="right"
  [(visible)]="isVisible"
  [elementAttr]="{ 'data-testid': 'side-menu-tooltip' }"
>
  <div *dxTemplate="let data = data of 'content'">
    <span>{{ tooltipContent }}</span>
  </div>
</dx-tooltip>

<div *ngIf="!_compactMode" class="logo" data-testid="side-menu-display-logo">
  <img [src]="largeLogo" [alt]="logoAltText" width="112" />
</div>
<div *ngIf="_compactMode" class="compact-logo" data-testid="side-menu-display-logo-compact">
  <img [src]="smallLogo" [alt]="logoAltText" width="24" />
</div>

<div class="menu-container" data-testid="side-menu-section-menu">
  <dx-tree-view
    id="top-menu"
    expandEvent="click"
    width="100%"
    [items]="items"
    (onInitialized)="onMenuInitialized($event)"
    (onItemClick)="onItemClick($event)"
    (onContentReady)="onContentReady($event)"
    (onSelectionChanged)="updateSelection($event)"
    [selectByClick]="true"
    selectionMode="single"
    keyExpr="path"
    [noDataText]="' '"
    [elementAttr]="{ 'data-testid': 'side-menu-nav-tree' }"
  >
    <div
      *dxTemplate="let item of 'profileTemplate'"
      [ngClass]="
        isMedigiAdmin ? 'medigi-admin-bottom-button-one' : 'bottom-button-one'
      "
      (click)="openUserProfile()"
      data-testid="side-menu-btn-profile"
    >
      <dxi-item class="d-flex flex-row">
        <i class="dx-icon-user-menu" style="margin-right: 18px"></i>
        <p class="mb-0">Profile</p>
      </dxi-item>
    </div>
    <div
      *dxTemplate="let item of 'collapseTemplate'"
      [ngClass]="
        isMedigiAdmin ? 'medigi-admin-bottom-button-two' : 'bottom-button-two'
      "
      (click)="toggleMenu()"
      data-testid="side-menu-btn-collapse"
    >
      <dxi-item class="d-flex flex-row">
        <i
          class="dx-icon-collapse {{ _compactMode ? 'rotate-icon' : '' }}"
          style="margin-right: 18px"
        ></i>
        <p class="mb-0">Collapse</p>
      </dxi-item>
    </div>
  </dx-tree-view>
</div>

<dx-popup
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [width]="'min(720px, 95vw)'"
  [height]="'auto'"
  [maxHeight]="'90vh'"
  title="{{ user?.first_name }} {{ user?.last_name }}"
  [showCloseButton]="true"
  [(visible)]="isProfilePopupOpen"
  (hiding)="closingPopup()"
  [elementAttr]="{ 'data-testid': 'side-menu-popup-user-profile' }"
>
  <app-user-profile></app-user-profile>
</dx-popup>
